module.exports = __webpack_public_path__ + "static/media/nft.3af61620.png";